import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: 'idle',
  user: null,
  accessToken: null,
  refreshToken: null,
  error: null,
  hydrated: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart(state) {
      state.status = 'loading';
      state.error = null;
    },
    loginSuccess(state, action) {
      state.status = 'succeeded';
      state.user = action.payload.user;
      state.accessToken = action.payload.tokens.accessToken;
      state.refreshToken = action.payload.tokens.refreshToken;
      state.hydrated = true;
    },
    loginFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    setProfileCompletion(state, action) {
      if (state.user) {
        state.user = { ...state.user, profileCompleted: Boolean(action.payload) };
      }
    },
    setProfileCompletionPercent(state, action) {
      if (state.user) {
        const percent = Number.isFinite(action.payload) ? Number(action.payload) : 0;
        state.user = { ...state.user, profileCompletionPercent: Math.min(Math.max(Math.round(percent), 0), 100) };
      }
    },
    setMpinSet(state, action) {
      if (state.user) state.user.mpinSet = Boolean(action.payload);
    },
    setStaffDuties(state, action) {
      if(state.user?.role==='SHOP_OPERATOR' && String(state.user.id)===String(action.payload.userId) && Array.isArray(action.payload.duties) && JSON.stringify(state.user.staffModules)!==JSON.stringify(action.payload.duties))state.user.staffModules=action.payload.duties;
    },
    setUserPhoto(state, action) {
      if (state.user && String(state.user.id) === String(action.payload.userId)) state.user.profilePhotoUrl = action.payload.url;
    },
    setCustomerName(state, action) {
      if (state.user && ['CUSTOMER', 'USER'].includes(state.user.role)) state.user.name = action.payload;
    },
    setPasswordSet(state, action) {
      if (state.user) state.user.passwordSet = Boolean(action.payload);
    },
    setUserPhone(state, action) {
      if (state.user) { state.user.phone = typeof action.payload === 'string' ? action.payload : action.payload.phone; state.user.phoneVerified = typeof action.payload === 'string' ? true : action.payload.verified === true; }
    },
    tokensRefreshed(state, action) {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
    },
    hydrateComplete(state) {
      state.hydrated = true;
    },
    logout(state) {
      Object.assign(state, initialState);
      state.hydrated = true;
    }
  }
});

export const { loginStart, loginSuccess, loginFailure, setProfileCompletion, setProfileCompletionPercent, setPasswordSet, setMpinSet, setCustomerName, setUserPhoto, setStaffDuties, setUserPhone, tokensRefreshed, hydrateComplete, logout } = authSlice.actions;
export default authSlice.reducer;
